import Swiper from 'swiper';
import {Navigation} from 'swiper/modules';
import 'swiper/swiper-bundle.css';

document.querySelectorAll('[data-slider]').forEach(slider => {

    const options = {
      modules: [Navigation],
      loop: false,
      autoHeight: true,
      allowTouchMove: false,
      navigation: {
        nextEl: slider.querySelector('.swiper-button-next'),
        prevEl: slider.querySelector('.swiper-button-prev'),
      },
      breakpoints: {
        640: {
          slidesPerView: 2,
        },
        1024: {
          slidesPerView: slider.dataset.slidesperview,
          allowTouchMove: true,
        }
      }
    }

    const swiper = new Swiper(slider.querySelector('.swiper'), options);
  }
)
